<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">回单下载</h1>
        <p class="text-gray-600">用于下载指定流水号的回单</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                用于下载指定流水号的回单。
                <br />
                说明：
                <br />- 交易流水号可从对账单查询接口获取 <br />- 四个参数传其一
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div
                class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg"
              >
                <span
                  class="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full"
                  >GET</span
                >
                <code class="text-sm font-mono">/api/v2/ebill/download</code>
              </div>

              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求头参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-id
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            APP ID
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            4d9414e89bc24b0d89b678d9f20bc56a
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-secret
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            API Key
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            8201e508ef948b8fcdca855729e7ee34
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-customer-code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            客户编号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            CUSTFA48DD8EFF437956
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    查询参数（四个参数必须传一个）
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            bankStatementId
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            资金管理系统中流水id
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            2470402
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            trxNum
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            与流水关联的支付单交易流水号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            13134243213231
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            instructionId
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            与流水关联的支付单电子凭证号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            FK13234123412341
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            bankTrxNumber
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            记账流水号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            dbd80e64ae56e78cd5803680c1d940ed
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            二进制文件流
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Binary
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回回单文件（二进制内容）。
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <!-- 右侧"试一试"区域 -->
        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>填写参数并下载回单文件</CardDescription>
            </CardHeader>
            <CardContent>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button
                    v-for="language in languages"
                    :key="language.id"
                    @click="activeLanguage = language.id"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                    :class="[
                      activeLanguage === language.id
                        ? 'border-[var(--primary)] text-[var(--primary)]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    ]"
                  >
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <div class="mt-6">
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ getRequestText() }}</code></pre>
                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-customer-code</label
                    >
                    <input
                      v-model="customerCode"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >bankStatementId (四选一)</label
                      >
                      <input
                        v-model="bankStatementId"
                        type="text"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >trxNum (四选一)</label
                      >
                      <input
                        v-model="trxNum"
                        type="text"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                  </div>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >instructionId (四选一)</label
                      >
                      <input
                        v-model="instructionId"
                        type="text"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >bankTrxNumber (四选一)</label
                      >
                      <input
                        v-model="bankTrxNumber"
                        type="text"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                  </div>
                  <button
                    @click="downloadReceipt"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ loading ? "下载中..." : "下载回单" }}
                  </button>
                </div>
              </div>

              <div v-if="downloadUrl" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">下载链接</h3>
                <p class="text-sm text-gray-600 mb-2">
                  回单已生成，点击下面链接保存到本地。
                </p>
                <a
                  :href="downloadUrl"
                  :download="downloadFilename"
                  class="text-blue-600 hover:underline"
                  >{{ downloadFilename }}</a
                >
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import Sidebar from "./Sidebar.vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import httpService from "@/lib/http";
import hljs from "highlight.js/lib/core";
import { useSystemStore } from "@/stores/system";
// 使用代码高亮
const highlightCode = () => {
  nextTick(() => {
    // 等待DOM更新完成后再处理
    setTimeout(() => {
      // 找到所有代码块
      const allCodeBlocks = document.querySelectorAll("pre code");

      // 语言映射表
      const languageMap: { [key: string]: string } = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };

      const langClass = languageMap[activeLanguage.value];

      // 处理所有代码块
      allCodeBlocks.forEach((block) => {
        // 清除之前的高亮
        block.className = "";
        block.removeAttribute("data-highlighted");

        // 重新添加基础类和语言类
        block.classList.add("hljs");
        if (langClass) {
          block.classList.add(langClass);
        }

        try {
          hljs.highlightElement(block as HTMLElement);
        } catch (error) {
          console.warn("代码高亮失败:", error);
        }
      });
    }, 100); // 减少延迟时间
  });
};

// 初始化代码高亮
highlightCode();

// 系统配置
const systemStore = useSystemStore();

// 默认值
const DEFAULT_APP_ID = "登录后自动获取";
const DEFAULT_APP_SECRET = "登录后自动获取";
const DEFAULT_CUSTOMER_CODE = "登录后自动获取";

const appId = ref(DEFAULT_APP_ID);
const authorization = ref(DEFAULT_APP_SECRET);
const customerCode = ref(DEFAULT_CUSTOMER_CODE);
const bankStatementId = ref("2470402");
const trxNum = ref("");
const instructionId = ref("");
const bankTrxNumber = ref("");
const loading = ref(false);
const activeLanguage = ref("curl");
const downloadUrl = ref("");
const downloadFilename = ref("");

// 获取应用信息
const getApplicationInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/application/get");

    if (response) {
      return {
        appId: response.appId,
        appSecret: response.appSecret,
      };
    }
    return null;
  } catch (error) {
    console.log("获取应用信息失败:", error);
    return null;
  }
};

// 获取客户信息
const getCustomerInfo = async () => {
  try {
    const response = await httpService.get<any>(
      "/nxb/console/customer/listWithSummary",
      {
        pageNow: 1,
        pageSize: 10,
      }
    );

    if (response) {
      return response.customers[0].customerCode;
    }
    return null;
  } catch (error) {
    console.log("获取客户信息失败:", error);
    return null;
  }
};

// 登录后自动获取用户信息
const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");

  if (userInfoStr) {
    const appInfo = await getApplicationInfo();

    if (appInfo) {
      appId.value = appInfo.appId;
      authorization.value = appInfo.appSecret;
    }

    const customerCodeValue = await getCustomerInfo();
    if (customerCodeValue) {
      customerCode.value = customerCodeValue;
    }
  }
};

// 组件挂载时登录后自动获取用户信息
onMounted(() => {
  autoFetchUserInfo();
});

// 监听响应式变量变化，重新应用代码高亮
watch(
  [
    appId,
    authorization,
    customerCode,
    bankStatementId,
    trxNum,
    instructionId,
    bankTrxNumber,
    activeLanguage,
  ],
  () => {
    // 更新示例代码高亮
    highlightCode();
  },
  { flush: "post" }
);

// 语言选项
const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

// 获取请求文本（对齐：回单下载 GET /ebill/download）
const getRequestText = () => {
  const baseUrl = import.meta.env.VITE_API_URL + "/api/v2/ebill/download";
  const params = new URLSearchParams();
  if (bankStatementId.value)
    params.append("bankStatementId", bankStatementId.value);
  if (trxNum.value) params.append("trxNum", trxNum.value);
  if (instructionId.value) params.append("instructionId", instructionId.value);
  if (bankTrxNumber.value) params.append("bankTrxNumber", bankTrxNumber.value);
  const qs = params.toString() || "bankStatementId=<或填任一必要参数>";

  switch (activeLanguage.value) {
    case "curl":
      return (
        `curl -X GET '${baseUrl}?${qs}' \\\n` +
        `  -H 'x-app-id: ${appId.value}' \\\n` +
        `  -H 'x-app-secret: ${authorization.value}' \\\n` +
        `  -H 'x-customer-code: ${customerCode.value}' \\\n` +
        `  --output receipt.pdf`
      );

    case "javascript":
      return (
        `const axios = require('axios');\n\n` +
        `const config = {\n` +
        `  method: 'get',\n` +
        `  url: '${baseUrl}',\n` +
        `  params: { ${qs} },\n` +
        `  responseType: 'blob',\n` +
        `  headers: { \n` +
        `    'x-app-id': '${appId.value}',\n` +
        `    'x-app-secret': '${authorization.value}',\n` +
        `    'x-customer-code': '${customerCode.value}'\n` +
        `  }\n` +
        `};\n\n` +
        `axios(config)\n` +
        `  .then(function (response) {\n` +
        `    const url = URL.createObjectURL(response.data);\n` +
        `    const a = document.createElement('a');\n` +
        `    a.href = url;\n` +
        `    a.download = 'receipt.pdf';\n` +
        `    a.click();\n` +
        `    URL.revokeObjectURL(url);\n` +
        `  })\n` +
        `  .catch(function (error) {\n` +
        `    console.log(error);\n` +
        `  });`
      );

    case "python":
      return (
        `import requests\n\n` +
        `url = "${baseUrl}"\n\n` +
        `params = { ${qs} }\n\n` +
        `headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}'\n` +
        `}\n\n` +
        `with requests.get(url, headers=headers, params=params, stream=True) as r:\n` +
        `  r.raise_for_status()\n` +
        `  with open('receipt.pdf', 'wb') as f:\n` +
        `    for chunk in r.iter_content(chunk_size=8192):\n` +
        `      f.write(chunk)`
      );

    case "java":
      return (
        `OkHttpClient client = new OkHttpClient().newBuilder()\n` +
        `  .build();\n` +
        `HttpUrl url = HttpUrl.parse("${baseUrl}").newBuilder()\n` +
        (bankStatementId.value
          ? `  .addQueryParameter("bankStatementId", "${bankStatementId.value}")\n`
          : "") +
        (trxNum.value
          ? `  .addQueryParameter("trxNum", "${trxNum.value}")\n`
          : "") +
        (instructionId.value
          ? `  .addQueryParameter("instructionId", "${instructionId.value}")\n`
          : "") +
        (bankTrxNumber.value
          ? `  .addQueryParameter("bankTrxNumber", "${bankTrxNumber.value}")\n`
          : "") +
        `  .build();\n` +
        `Request request = new Request.Builder()\n` +
        `  .url(url)\n` +
        `  .get()\n` +
        `  .addHeader("x-app-id", "${appId.value}")\n` +
        `  .addHeader("x-app-secret", "${authorization.value}")\n` +
        `  .addHeader("x-customer-code", "${customerCode.value}")\n` +
        `  .build();\n` +
        `Response response = client.newCall(request).execute();\n` +
        `byte[] bytes = response.body().bytes();\n` +
        `Files.write(Paths.get("receipt.pdf"), bytes);`
      );

    case "csharp":
      return (
        `var client = new HttpClient();\n` +
        `var builder = new UriBuilder("${baseUrl}");\n` +
        `var query = HttpUtility.ParseQueryString(string.Empty);\n` +
        (bankStatementId.value
          ? `query["bankStatementId"] = "${bankStatementId.value}";\n`
          : "") +
        (trxNum.value ? `query["trxNum"] = "${trxNum.value}";\n` : "") +
        (instructionId.value
          ? `query["instructionId"] = "${instructionId.value}";\n`
          : "") +
        (bankTrxNumber.value
          ? `query["bankTrxNumber"] = "${bankTrxNumber.value}";\n`
          : "") +
        `builder.Query = query.ToString();\n` +
        `var request = new HttpRequestMessage(HttpMethod.Get, builder.Uri);\n` +
        `request.Headers.Add("x-app-id", "${appId.value}");\n` +
        `request.Headers.Add("x-app-secret", "${authorization.value}");\n` +
        `request.Headers.Add("x-customer-code", "${customerCode.value}");\n` +
        `var response = await client.SendAsync(request);\n` +
        `var bytes = await response.Content.ReadAsByteArrayAsync();\n` +
        `File.WriteAllBytes("receipt.pdf", bytes);`
      );

    case "php":
      return (
        `<?php\n\n` +
        `$curl = curl_init();\n\n` +
        `curl_setopt_array($curl, array(\n` +
        `  CURLOPT_URL => '${baseUrl}?${qs}',\n` +
        `  CURLOPT_RETURNTRANSFER => true,\n` +
        `  CURLOPT_CUSTOMREQUEST => 'GET',\n` +
        `  CURLOPT_HTTPHEADER => array(\n` +
        `    'x-app-id: ${appId.value}',\n` +
        `    'x-app-secret: ${authorization.value}',\n` +
        `    'x-customer-code: ${customerCode.value}'\n` +
        `  ),\n` +
        `));\n\n` +
        `$response = curl_exec($curl);\n` +
        `curl_close($curl);\n` +
        `file_put_contents('receipt.pdf', $response);`
      );

    case "ruby":
      return (
        `require "uri"\n` +
        `require "net/http"\n` +
        `require "openssl"\n\n` +
        `url = URI("${baseUrl}?${qs}")\n` +
        `https = Net::HTTP.new(url.host, url.port)\n` +
        `https.use_ssl = true\n` +
        `request = Net::HTTP::Get.new(url)\n` +
        `request["x-app-id"] = "${appId.value}"\n` +
        `request["x-app-secret"] = "${authorization.value}"\n` +
        `request["x-customer-code"] = "${customerCode.value}"\n` +
        `response = https.request(request)\n` +
        `File.write("receipt.pdf", response.body)`
      );

    default:
      return "";
  }
};

// 下载回单（调用 /ebill/download 返回二进制并生成下载链接）
const downloadReceipt = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  if (
    !bankStatementId.value &&
    !trxNum.value &&
    !instructionId.value &&
    !bankTrxNumber.value
  ) {
    alert(
      "请至少填写一个流水标识参数：bankStatementId / trxNum / instructionId / bankTrxNumber"
    );
    return;
  }

  loading.value = true;
  downloadUrl.value = "";
  downloadFilename.value = "";

  try {
    const params: Record<string, string> = {};
    if (bankStatementId.value) params.bankStatementId = bankStatementId.value;
    if (trxNum.value) params.trxNum = trxNum.value;
    if (instructionId.value) params.instructionId = instructionId.value;
    if (bankTrxNumber.value) params.bankTrxNumber = bankTrxNumber.value;

    const res = await httpService.get<any>("/api/v2/ebill/download", params, {
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
      responseType: "blob",
    });

    const raw = res && (res as any).data ? (res as any).data : res;
    const blob =
      raw instanceof Blob
        ? raw
        : new Blob([raw], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const id =
      trxNum.value ||
      instructionId.value ||
      bankStatementId.value ||
      bankTrxNumber.value ||
      "receipt";
    downloadUrl.value = url;
    downloadFilename.value = `receipt_${id}.pdf`;
  } catch (error) {
    console.error("下载失败:", error);
    alert("下载失败，请稍后重试或检查参数与权限");
  } finally {
    loading.value = false;
  }
};
</script>
